import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable, Subscriber, Subscription } from "rxjs";
export interface ITransaction {
    user: string
    tokensBought: string
    amountPaid: string
    usdEq: string
    isNativeToken: boolean
    timestamp: string
    projectName: string
    slug: string
    logo: string
    chain: string
    transactionHash: string
    explorerUrl: string
    stableCoin: any
}

export interface ITransactionAPiResponse {
    data : ITransaction
}

// Run the scrollar initially!
const initialTransactions = [
    {
        "user": "0x1a29C121aD345a97dD5f8307626c4EBB8F9110f2",
        "tokensBought": "10",
        "amountPaid": "0.000012513846101442",
        "usdEq": "0.01",
        "isNativeToken": true,
        "timestamp": "1753870696",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "bsc",
        "transactionHash": "0x2b008dbea7032bb8ce1e23d768fb30860be3888d6341389c4c7d37a792c238b0",
        "explorerUrl": "https://bscscan.com/tx/0x2b008dbea7032bb8ce1e23d768fb30860be3888d6341389c4c7d37a792c238b0",
        "stableCoin": null
    },
    {
        "user": "0x1a29C121aD345a97dD5f8307626c4EBB8F9110f2",
        "tokensBought": "10",
        "amountPaid": "0.000012499687507968",
        "usdEq": "0.01",
        "isNativeToken": true,
        "timestamp": "1753870643",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "bsc",
        "transactionHash": "0xb48c5b6016b4f2e5b89526ee3f26eb88757623eadad31eb3e99b1a63b2a6f7be",
        "explorerUrl": "https://bscscan.com/tx/0xb48c5b6016b4f2e5b89526ee3f26eb88757623eadad31eb3e99b1a63b2a6f7be",
        "stableCoin": null
    },
    {
        "user": "0x1a29C121aD345a97dD5f8307626c4EBB8F9110f2",
        "tokensBought": "10",
        "amountPaid": "0.000012504858450129",
        "usdEq": "0.01",
        "isNativeToken": true,
        "timestamp": "1753870586",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "bsc",
        "transactionHash": "0xd75f64c71e2c11e0c32b9b2a8b3b159c2d1e92ea17b77f73ef6423ce4be598a3",
        "explorerUrl": "https://bscscan.com/tx/0xd75f64c71e2c11e0c32b9b2a8b3b159c2d1e92ea17b77f73ef6423ce4be598a3",
        "stableCoin": null
    },
    {
        "user": "0x0E404BA121b475c4cdc7De8FfD8A7C6cf57c9f37",
        "tokensBought": "1006216",
        "amountPaid": "0.267299840989778367",
        "usdEq": "1006.216",
        "isNativeToken": true,
        "timestamp": "1753804187",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0x2f9cd79b60f0654dd456ad2f4f58e6546659c88382b4e95f0b6c40a6c94a11d8",
        "explorerUrl": "https://etherscan.io/tx/0x2f9cd79b60f0654dd456ad2f4f58e6546659c88382b4e95f0b6c40a6c94a11d8",
        "stableCoin": null
    },
    {
        "user": "0xddb3742E3523d8e451FfF9818B85F2516F24002B",
        "tokensBought": "37267",
        "amountPaid": "0.009899925238881184",
        "usdEq": "37.267",
        "isNativeToken": true,
        "timestamp": "1753803059",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0x80d899833ebcba0fd03e3e65a6ef59863e39a3c6e422ecb372d2b27eb623871f",
        "explorerUrl": "https://etherscan.io/tx/0x80d899833ebcba0fd03e3e65a6ef59863e39a3c6e422ecb372d2b27eb623871f",
        "stableCoin": null
    },
    {
        "user": "0xDF29ed6BFDcCb8498FFFD49938033BB3eEFa611A",
        "tokensBought": "4974",
        "amountPaid": "4.974",
        "usdEq": "4.974",
        "isNativeToken": false,
        "timestamp": "1753472027",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0xd3634bf536b60a292af3f1bd0ac26577caa2bd389dee3cc14f4308206c43ae55",
        "explorerUrl": "https://etherscan.io/tx/0xd3634bf536b60a292af3f1bd0ac26577caa2bd389dee3cc14f4308206c43ae55",
        "stableCoin": "usdc"
    },
    {
        "user": "0xDF29ed6BFDcCb8498FFFD49938033BB3eEFa611A",
        "tokensBought": "4974",
        "amountPaid": "4.974",
        "usdEq": "4.974",
        "isNativeToken": false,
        "timestamp": "1753471943",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0x8a2b4b2f4f5751bb3dbf0b0cb500d95ee5f121c54cddb5c2913fc19a009a58d2",
        "explorerUrl": "https://etherscan.io/tx/0x8a2b4b2f4f5751bb3dbf0b0cb500d95ee5f121c54cddb5c2913fc19a009a58d2",
        "stableCoin": "usdt"
    },
    {
        "user": "0xDF29ed6BFDcCb8498FFFD49938033BB3eEFa611A",
        "tokensBought": "361867",
        "amountPaid": "0.098999789342941483",
        "usdEq": "361.867",
        "isNativeToken": true,
        "timestamp": "1753471511",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0xcbd80a0775bda62a699859ba6837ab60bcdfa0133055f125db5eb93ee7e654ea",
        "explorerUrl": "https://etherscan.io/tx/0xcbd80a0775bda62a699859ba6837ab60bcdfa0133055f125db5eb93ee7e654ea",
        "stableCoin": null
    },
    {
        "user": "0xDFc3c70A3D58Bf6e5cd822C24A4e200dFe07cBb5",
        "tokensBought": "750000",
        "amountPaid": "0.201724610940467032",
        "usdEq": "750.0",
        "isNativeToken": true,
        "timestamp": "1753440695",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0x07e6dd89199b814c479503aa3d2c42007ebafac3d83322e750e5280ec57a67d7",
        "explorerUrl": "https://etherscan.io/tx/0x07e6dd89199b814c479503aa3d2c42007ebafac3d83322e750e5280ec57a67d7",
        "stableCoin": null
    },
    {
        "user": "0xDF29ed6BFDcCb8498FFFD49938033BB3eEFa611A",
        "tokensBought": "19899",
        "amountPaid": "19.899",
        "usdEq": "19.899",
        "isNativeToken": false,
        "timestamp": "1753389923",
        "projectName": "Pepenode",
        "slug": "$NODE",
        "logo": "https://web3toolkit.s3.eu-west-2.amazonaws.com/uploads/presale/Pepenode.png",
        "chain": "eth",
        "transactionHash": "0x64a66fb9306251cea74cc4f952426bbd39d7ffdf96f94aeba79b61bb945a0a5c",
        "explorerUrl": "https://etherscan.io/tx/0x64a66fb9306251cea74cc4f952426bbd39d7ffdf96f94aeba79b61bb945a0a5c",
        "stableCoin": "usdc"
    }
]

export interface Project {
    name: string
    ticker: string
    logo: string
}

enum EVENTS {
    TOKENS_BOUGHT = "TokensBought",
    TOKENS_BOUGHT_AND_STAKED = "TokenBoughtAndStaked",
    TOKENS_CLAIMED = "TokensClaimed",
    TOKENS_CLAIMED_AND_STAKED = "TokensClaimedAndStaked"
}

const CLAIM_EVENTS = [EVENTS.TOKENS_CLAIMED, EVENTS.TOKENS_CLAIMED_AND_STAKED]


interface NotificationResponse {
    event: string;
    data: {
        user: string;
        tokensBought: string;
        amountPaid: string;
        usdEq: string;
        isNativeToken: boolean;
        timestamp: string;
        projectName: string;
        slug: string;
        chain: string;
        transactionHash: string;
        explorerUrl: string;
        logo: string;
        // for claim events
        amount: string;
        blockNumber: string;
    };
    timestamp: string;
}

@Injectable({
    providedIn: "root"
})

export class PresaleTransacationService {
    private eventSource: EventSource | null = null;
    private subscriptions: Subscription = {} as Subscription;
    transactions: ITransaction[] = initialTransactions;
    url = environment.transactionUrl
    sseUrl = environment.sseUrl
    constructor(private http: HttpClient) {

    }

    async getTransactions(limit: number = 10) {
        // no need to create url and slug dynamic. We are using it for only one purpose here
        return this.http.get(this.url)
    }

   setAllTransaction(transactions: ITransactionAPiResponse[]) {
        const filteredTransaction = transactions.map((item) => item.data).filter((item) => !!item.usdEq) // filtering out corrupt entries!
        this.transactions = filteredTransaction
    }

    startListner() {
        if (this.sseUrl != '' && environment.production) {
            this.subscriptions = this.connectToServerSentEvents(this.sseUrl).subscribe({
                next: (data: any) => {
                    const item: NotificationResponse = JSON.parse(data.data);
                    const transaction_item: ITransaction = {...item.data} as any
                    console.log({transaction_item});
                    const new_item = [{ ...transaction_item }];
                    this.transactions = [...new_item, ...this.transactions];

                },
                error: (error: any) => {
                    console.error('Notification Error:', error);
                    this.destroySubscription();
                },
            });
        }
    }

    connectToServerSentEvents(url: string): Observable<Event> {
        return new Observable((subscriber: Subscriber<Event>) => {
            this.eventSource = new EventSource(url);

            this.eventSource.onerror = (error: any) => {
                subscriber.error(error);
            };

            this.eventSource.onmessage = (event: MessageEvent) => {
                subscriber.next(event);
            };

            return () => {
                this.closeEventSource();
                subscriber.complete();
            };
        });

    }
    destroySubscription() {
        if (Object.keys(this.subscriptions).length) this.subscriptions.unsubscribe()
    }

    closeEventSource(): void {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
            this.subscriptions.unsubscribe()
        }
    }

    isClaimEvents(event: string): Boolean {
        return CLAIM_EVENTS.includes(event as EVENTS.TOKENS_BOUGHT)
    }

    getUsdEqAmount(data: NotificationResponse) {
        if (!this.isClaimEvents(data.event) && data.data.isNativeToken) {
            return data.data.amountPaid
        }
        return data.data.usdEq
    }

}